export default "__VITE_PUBLIC_ASSET__46ff0f4b__"